import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const nullableAnnualPropertyTaxSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  (graphDataOrEmptyObject) => {
    const propertyTax = get(
      graphDataOrEmptyObject,
      `${HOME_PURCHASE_GOAL_GRAPH_NODE}.PropertyTax`,
      null,
    );
    if (propertyTax !== null) {
      return propertyTax;
    }
    return null;
  },
);

export default nullableAnnualPropertyTaxSelector;
